module.exports = __webpack_public_path__ + "img/mov.490dcdd6.svg";